import { magento } from "@jti/magento";
export const checkXSellingPopupFlag = async (cartId) => {
    if (!cartId)
        return false;
    try {
        const response = await magento.getXSellingPopup(cartId);
        return !!response.cart.xselling_popup;
    }
    catch (err) {
        console.error("useXSellingDialog: Error fetching xselling_popup:", err);
        return false;
    }
};
//# sourceMappingURL=checkXSellingPopupFlag.js.map